<template>
  <div>
    <!-- <div :for='name'> -->
    <label class="switch">
      <input type="checkbox" :class="[type]" :value="value" @input="update"
        :checked='checkinput'>
      <span class="slider"></span>
    </label>
    <!-- </div> -->
  </div>
</template>
<script>
import _ from "lodash";
  export default {
    name: "BM-switch",
    methods:{
        update(){
            this.$emit('input', e.target.value);
        }
    },
    computed: {
        checkdata:{
            get(){
                return this.input;
            },
            set(data){
                console.log(data);
            }
        }
    },
    props: {
      type: {
        type: String,
        default: "default"
      },
      name: {
        type: String,
        default: () => {
          const string = "BST____" + Math.random() * 1000000000000000;
          return string;
        }
      },
      input: {
        type: Array,
        default: () => {
          return [];
        }
      },
      value:[Object,String]
    }
  }

</script>
